/* eslint-disable no-unreachable */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  Typography,
  Upload,
  notification,
  Modal,
  Radio,
  DatePicker,
  Flex,
} from "antd";
import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import {
  createRetailDetailsService,
  getExchangeEvaluationOfficersService,
  sendExchangeLeadForFinalInspectionService,
} from "../../../services/master-services";
import Loader from "../../../components/common/Loader";
import { API_RESPONSE_CODES } from "../../../utills/constant";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CommanPreviewImage from "../../../components/common/CommanPreviewImage";
import {
  fetchLeadDetailsServices,
  handleTabChange,
} from "../../auth/slice/authSlice";

import QuotationVehicleDetails from "./QuotationVehicleDetails";
import ViewRetailSection from "./ViewRetailSection";

const { Title } = Typography;

const Retail = (props) => {
  const { isLeadConverted } = props;

  const [form] = Form.useForm();
  const { id } = useParams();
  const dispatch = useDispatch();
  const leadViewDetails = useSelector((state) => state?.auth?.leadDetails);

  const [isLoading, setIsLoading] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [fileList, setFileList] = useState({
    document: [],
    iconnect_doc: [],
    attachments: [],
  });
  const [excVehicleIds, setExcVehicleIds] = useState({
    make_id: leadViewDetails?.vehicle_detail?.model?.make_id,
    model_id: leadViewDetails?.vehicle_detail?.model?.id,
    vehicle_variant_id: leadViewDetails?.vehicle_detail?.vehicle_variant_id,
    color_type_id: leadViewDetails?.vehicle_detail?.color_id,
    fuel_type_id: leadViewDetails?.vehicle_detail?.fuel_type_id,
    seater_id: leadViewDetails?.vehicle_detail?.seater_id,
  });

  const roleType = useSelector((state) => state?.auth?.userData?.role);
  // const isFinalAssessmentCompleted =
  //   leadViewDetails?.exchange_stage_history?.filter(
  //     (stage) => stage.lead_exchange_stage_id === 7 && stage.status === 2
  //   )?.length > 0;


  useEffect(() => {
    form.setFieldsValue({

      retail_status:
        leadViewDetails?.retail?.retail_status !== null &&
          leadViewDetails?.retail?.retail_status !== undefined
          ? leadViewDetails?.retail?.retail_status
          : 0,
      retail_date: leadViewDetails?.retail?.retail_date
        ? dayjs(leadViewDetails?.retail?.retail_date)
        : dayjs(),
      retail_remarks: leadViewDetails?.retail?.retail_remarks,
      chassis_number:
        leadViewDetails?.retail?.chassis_number ||
        leadViewDetails?.allocated_chassis_number,
    });
  }, [leadViewDetails, form]);

  useEffect(() => {
    // handleInsuranceTypeChange(leadViewDetails?.booking?.insurance_type?.id);
    // handleRoadTaxTypeChange(leadViewDetails?.booking?.road_tax_type?.id);
  }, []);
  const retailData = leadViewDetails?.retail;
  const isRetailed = leadViewDetails?.retail?.model?.model_name?.length > 0;
  const isExchangeEvaluationTeam =
    roleType === "Exchange Evaluation Team" ||
    roleType === "Procurement Manager";
  // const isLeadLostOrDropped =
  //   leadViewDetails?.lead_status?.name === "Lost" ||
  //   leadViewDetails?.lead_status?.name === "Dropped";
  const isLeadCancelled =
    leadViewDetails?.lead_status?.name === "Cancelled";
  const isEvaluationCompleted =
    leadViewDetails?.exchange_stage_history?.filter(
      (stage) => stage.lead_exchange_stage_id === 5 && stage.status === 2
    )?.length > 0;

  // Determine visibility for "Send for Final Inspection" button based on new conditions
  const sentForFinalInspection =
    leadViewDetails?.exchange_vehicle_detail?.sent_for_final_inspection;
  const inspectionOfficerDecision =
    leadViewDetails?.exchange_vehicle_detail?.inspection_officer_decision;
  const shouldShowSendForFinalInspection =
    isEvaluationCompleted &&
    (sentForFinalInspection === 0) &&
    (inspectionOfficerDecision === 0 ||
      inspectionOfficerDecision === null ||
      inspectionOfficerDecision === undefined ||
      inspectionOfficerDecision === 2);

  const [isFinalInspectionModalOpen, setIsFinalInspectionModalOpen] =
    useState(false);
  const [exchangeOfficers, setExchangeOfficers] = useState([]);
  const [isOfficersLoading, setIsOfficersLoading] = useState(false);
  const [finalInspectionForm] = Form.useForm();
  const [isEditMode, setIsEditMode] = useState(false);

  const openFinalInspectionModal = async () => {
    setIsFinalInspectionModalOpen(true);
    try {
      setIsOfficersLoading(true);
      const res = await getExchangeEvaluationOfficersService();
      setExchangeOfficers(res?.data?.data || []);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsOfficersLoading(false);
    }
  };

  const closeFinalInspectionModal = () => {
    setIsFinalInspectionModalOpen(false);
    finalInspectionForm.resetFields();
  };

  const handleSendForFinalInspection = async () => {
    try {
      const values = await finalInspectionForm.validateFields();
      const payload = {
        lead_id: leadViewDetails?.id,
        final_inspection_officer_id: values?.exchange_officer_id,
      };
      setIsOfficersLoading(true);
      const res = await sendExchangeLeadForFinalInspectionService(payload);
      if (
        res?.data?.status === API_RESPONSE_CODES.OK ||
        res?.data?.status === API_RESPONSE_CODES.CREATED
      ) {
        notification.success({
          message: res?.data?.message || "Sent for Final Inspection",
        });
        closeFinalInspectionModal();
        dispatch(fetchLeadDetailsServices({ id }));
      }
    } catch (error) {
      if (error?.errorFields) return; // validation error
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsOfficersLoading(false);
    }
  };

  const validateFile = (file) => {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/gif";
    if (!isJpgOrPng) {
      notification.error({
        description: "You can only upload JPG/PNG/GIF file",
      });
      return Upload.LIST_IGNORE; // Reject file upload
    }

    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      notification.error({
        description: "Image must be smaller than 10MB",
      });
      return Upload.LIST_IGNORE; // Reject file upload
    }

    return true; // Allow file upload
  };

  const handleFileChange = (info, field) => {
    let newFileList = [...info.fileList];
    // For attachments, keep all files (up to maxCount). For other fields, keep only the last one
    if (field !== "attachments") {
      newFileList = newFileList.slice(-1);
    }

    setFileList((prev) => ({
      ...prev,
      [field]: newFileList,
    }));

    // Trigger validation for the field after state update
    setTimeout(() => {
      form.validateFields([field]).catch(() => {
        // Ignore validation errors, just trigger the validation
      });
    }, 0);
  };

  const handleSave = async (values) => {
    delete values.document;
    delete values.iconnect_doc;
    delete values.attachments; // Will handle separately
    values.lead_id = leadViewDetails?.id;
    values.booking_id = leadViewDetails?.booking?.id;
    values.retail_date = values.retail_date
      ? dayjs(values?.retail_date).format("YYYY-MM-DD")
      : "";

    const formData = new FormData();

    // Handle multiple attachments file upload
    if (fileList?.attachments?.length > 0) {
      fileList.attachments.forEach((file, index) => {
        if (file.originFileObj) {
          formData.append(`attachments[${index}]`, file.originFileObj);
        }
      });
    }

    // Handle other file uploads
    Object.keys(fileList).forEach((key) => {
      if (
        key !== "attachments" &&
        fileList[key]?.length > 0 &&
        fileList[key][0].originFileObj
      ) {
        formData.append(key, fileList[key][0].originFileObj);
      }
    });

    // Explicitly add chassis_number since it's disabled and won't be in form values
    const chassisNumber =
      form.getFieldValue("chassis_number") ||
      leadViewDetails?.retail?.chassis_number ||
      leadViewDetails?.allocated_chassis_number ||
      "";
    values.chassis_number = chassisNumber;

    const filteredValues = Object.fromEntries(
      Object.entries(values).filter(([, v]) => v !== undefined && v !== null)
    );

    for (let key in filteredValues) {
      formData.append(key, filteredValues[key]);
    }
    try {
      setIsLoading(true);
      const res = await createRetailDetailsService(formData);
      if (
        res.data.status === API_RESPONSE_CODES.OK ||
        res.data.status === API_RESPONSE_CODES.CREATED
      ) {
        form.resetFields();
        setIsEditMode(false);
        notification.success({
          message: res.data.message,
        });
        dispatch(fetchLeadDetailsServices({ id: id }));
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };



  const handleCancel = () => {
    form.resetFields();
    setIsEditMode(false);
    // Restore original document file list (Upload Pictures)
    if (leadViewDetails?.retail?.document_path) {
      const documentFile = {
        uid: "-1",
        name: leadViewDetails?.retail?.document_file_name || "document",
        status: "done",
        url: leadViewDetails?.retail?.document_path,
      };
      setFileList((prev) => ({
        ...prev,
        document: [documentFile],
      }));
    } else {
      setFileList((prev) => ({
        ...prev,
        document: [],
      }));
    }

    // Restore original iconnect_doc file list
    if (leadViewDetails?.retail?.iconnect_doc_path) {
      const iconnectFile = {
        uid: "-2",
        name: leadViewDetails?.retail?.iconnect_doc_file_name || "iconnect_doc",
        status: "done",
        url: leadViewDetails?.retail?.iconnect_doc_path,
      };
      setFileList((prev) => ({
        ...prev,
        iconnect_doc: [iconnectFile],
      }));
    } else {
      setFileList((prev) => ({
        ...prev,
        iconnect_doc: [],
      }));
    }

    // Reset attachments if needed
    setFileList((prev) => ({
      ...prev,
      attachments: [],
    }));
  };

  const handleEdit = () => {
    setIsEditMode(true);
    // Pre-fill form with retail data when entering edit mode
    form.setFieldsValue({
      retail_status:
        leadViewDetails?.retail?.retail_status !== null &&
          leadViewDetails?.retail?.retail_status !== undefined
          ? leadViewDetails?.retail?.retail_status
          : 0,
      retail_date: leadViewDetails?.retail?.retail_date
        ? dayjs(leadViewDetails?.retail?.retail_date)
        : dayjs(),
      retail_remarks: leadViewDetails?.retail?.retail_remarks,
      chassis_number:
        leadViewDetails?.retail?.chassis_number ||
        leadViewDetails?.allocated_chassis_number,
      engine_number: leadViewDetails?.retail?.engine_number,
      vehicle_model_id: leadViewDetails?.retail?.vehicle_model_id,
      vehicle_variant_id: leadViewDetails?.retail?.vehicle_variant_id,
      color_id: leadViewDetails?.retail?.color_id,
      fuel_type_id: leadViewDetails?.retail?.fuel_type_id,
      seater_id: leadViewDetails?.retail?.seater_id,
      rto_location_id: leadViewDetails?.retail?.rto_location_id,
      delivery_feedback: leadViewDetails?.retail?.delivery_feedback,
    });

    // Set file list for document (Upload Pictures)
    if (leadViewDetails?.retail?.document_path) {
      const documentFile = {
        uid: "-1",
        name: leadViewDetails?.retail?.document_file_name || "document",
        status: "done",
        url: leadViewDetails?.retail?.document_path,
      };
      setFileList((prev) => ({
        ...prev,
        document: [documentFile],
      }));
    }

    // Set file list for iconnect_doc
    if (leadViewDetails?.retail?.iconnect_doc_path) {
      const iconnectFile = {
        uid: "-2",
        name: leadViewDetails?.retail?.iconnect_doc_file_name || "iconnect_doc",
        status: "done",
        url: leadViewDetails?.retail?.iconnect_doc_path,
      };
      setFileList((prev) => ({
        ...prev,
        iconnect_doc: [iconnectFile],
      }));
    }

    // Set file list for attachments from retail_documents array
    if (
      leadViewDetails?.retail?.retail_documents &&
      Array.isArray(leadViewDetails?.retail?.retail_documents) &&
      leadViewDetails?.retail?.retail_documents.length > 0
    ) {
      const attachmentFiles = leadViewDetails.retail.retail_documents
        .filter((doc) => doc.document_path) // Only include documents with valid paths
        .map((doc, index) => ({
          uid: `-attachment-${index}`,
          name: doc.document_file_name || `attachment-${index}`,
          status: "done",
          url: doc.document_path,
        }));
      setFileList((prev) => ({
        ...prev,
        attachments: attachmentFiles,
      }));
    } else {
      // If no retail_documents, clear attachments
      setFileList((prev) => ({
        ...prev,
        attachments: [],
      }));
    }
  };

  const handleViewBooking = () => {
    dispatch(handleTabChange("bookings"));
  };



  const hasRetailData =
    leadViewDetails?.retail?.retail_status !== undefined &&
    leadViewDetails?.retail?.retail_status !== null;

  const shouldShowEditForm =
    isEditMode ||
    (!hasRetailData && !isLeadConverted && !isLeadCancelled);

  return (
    <div className="user-data lead-detail">
      <Loader loading={isLoading} />
      <Flex justify="space-between" align="center">
        <Title level={4} className="">
          Retail Detail
        </Title>
        {!isEditMode &&
          leadViewDetails &&
          leadViewDetails?.lead_status &&
          leadViewDetails?.lead_status?.name === "Open" &&
          leadViewDetails?.retail?.engine_number &&
          !isLeadConverted && (
            <Flex align="center" justify="end" gap={8}>
              <Button
                onClick={handleEdit}
                type="primary"
                className="secondary-button"
              >
                Edit
              </Button>
              {shouldShowSendForFinalInspection && (
                <Button
                  type="primary"
                  className="secondary-button ms-3"
                  onClick={openFinalInspectionModal}
                >
                  Send for Final Inspection
                </Button>
              )}
            </Flex>
          )}
      </Flex>

      {!isExchangeEvaluationTeam || isEditMode ? (
        shouldShowEditForm ? (
          <Form
            layout="vertical"
            form={form}
            onFinish={handleSave}
            
          >
            <div>
              <Row gutter={20}>
                {/* Retail Status */}
                <Col xs={24} sm={24} md={24} lg={8}>
                  <Flex align="baseline" className="lead-form-label">
                    <h6>
                      Retail Status:
                      {((!isRetailed && !isLeadConverted) || isEditMode) &&
                        (
                          <span className="asterisk inline-block ml-1">*</span>
                        )}
                    </h6>
                    <div className=" value " style={{ width: "100%" }}>
                      <Form.Item
                        name="retail_status"
                        label=""
                        rules={[
                          {
                            required: true,
                            message: "Please select retail status",
                          },
                        ]}
                      >
                        <Radio.Group>
                          <Radio value={0}>Not Retailed</Radio>
                          <Radio value={1}>Retailed</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  </Flex>
                </Col>
                {/* Booking redirect icon */}
                <Col xs={24} sm={24} md={24} lg={12}>
                  <Flex align="center">
                    <h6>Booking Details:</h6>
                    <Button
                      shape="circle"
                      icon={<EyeOutlined />}
                      onClick={handleViewBooking}
                    />
                  </Flex>
                </Col>

                {/* Date of Retail */}
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <Flex vertical className="lead-form-label" gap={8}>
                    <h6>
                      Date of Retail:
                      {((!isRetailed && !isLeadConverted) || isEditMode) &&
                        (
                          <span className="asterisk inline-block ml-1">*</span>
                        )}
                    </h6>
                    <div className=" w-100 value " style={{ width: "100%" }}>
                      <Form.Item
                        label=""
                        name="retail_date"
                        initialValue={dayjs()}
                        rules={[
                          {
                            required: true,
                            message: "Please select retail date",
                          },
                        ]}
                      >
                        <DatePicker
                          format="DD MMM YYYY"
                          placeholder="Select Date"
                        />
                      </Form.Item>
                    </div>
                  </Flex>
                </Col>
                {/* Engine Number */}
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <Flex vertical gap={8} className="lead-form-label ">
                    <h6>
                      Engine Number:
                      {((!isRetailed && !isLeadConverted) || isEditMode) &&
                        (
                          <span className="asterisk inline-block ml-1">*</span>
                        )}
                    </h6>
                    <div className=" value" style={{ width: "100%" }}>
                      <Form.Item
                        label=""
                        name="engine_number"
                        rules={[
                          {
                            required: true,
                            message: "Please input the engine number",
                          },
                          {
                            pattern: /^[a-zA-Z0-9]{1,30}$/,
                            message:
                              "Engine number must be 1-30 alphanumeric characters only",
                          },
                        ]}
                      >
                        <Input placeholder="Engine Number" />
                      </Form.Item>
                    </div>
                  </Flex>
                </Col>

                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <Flex gap={8} vertical className="lead-form-label ">
                    <h6>Chassis Number:</h6>
                    <div className=" value" style={{ width: "100%" }}>
                      <Form.Item
                        name="chassis_number"
                        className="mb-0"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value || value.trim() === "") {
                                return Promise.resolve();
                              }
                              if (!/^[a-zA-Z0-9]{1,30}$/.test(value)) {
                                return Promise.reject(
                                  "Chassis number must be 1-30 alphanumeric characters only"
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          className=""
                          placeholder="Chassis Number"
                          disabled
                        />
                      </Form.Item>
                    </div>
                  </Flex>
                </Col>

                {/* Attachment */}
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <Flex vertical className="lead-form-label" gap={8}>
                    <h6>
                      Attachment:
                      {((!isRetailed && !isLeadConverted) || isEditMode) &&
                        (
                          <span className="asterisk inline-block ml-1">*</span>
                        )}
                    </h6>
                    <div className=" value" style={{ width: "100%" }}>
                      <Form.Item
                        label=""
                        name="attachments"
                        rules={[
                          {
                            validator: () => {
                              if (
                                fileList?.attachments &&
                                fileList?.attachments?.length > 0
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error("Please upload attachment")
                              );
                            },
                          },
                        ]}
                      >
                        <Upload
                          maxCount={5}
                          beforeUpload={(file) => {
                            const isPdf = file.type === "application/pdf";
                            const isImage =
                              file.type === "image/jpeg" ||
                              file.type === "image/png" ||
                              file.type === "image/gif";
                            if (!isPdf && !isImage) {
                              notification.error({
                                description:
                                  "You can only upload PDF or JPG/PNG/GIF file",
                              });
                              return Upload.LIST_IGNORE;
                            }
                            const isLt10M = file.size / 1024 / 1024 < 10;
                            if (!isLt10M) {
                              notification.error({
                                description: "File must be smaller than 10MB",
                              });
                              return Upload.LIST_IGNORE;
                            }
                            return true;
                          }}
                          fileList={fileList?.attachments}
                          accept=".pdf,.jpg,.jpeg,.png,.gif"
                          customRequest={({ onSuccess }) => {
                            onSuccess("ok");
                          }}
                          onChange={(info) =>
                            handleFileChange(info, "attachments")
                          }
                        >
                          <Button icon={<UploadOutlined />}>
                            {" "}
                            Upload Attachements
                          </Button>
                        </Upload>
                      </Form.Item>
                    </div>
                  </Flex>
                </Col>

                {/* Retail Date */}
                {/* <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                <div className='lead-form-label d-flex align-items-baseline flex-nowrap'>
                  <h6 className='me-2'>
                    Retail Date:
                    {((!isRetailed && !isLeadConverted) || isEditMode) && <span className='asterisk inline-block ml-1'>*</span>}
                  </h6>
                  <div className='m-0 w-50 value mb-sm-2'>
                    {retailData?.retail_date || isLeadConverted ? (
                      <>{retailData?.retail_date ? dayjs(retailData?.retail_date).format('DD/MM/YYYY') : '-'} </>
                    ) : (
                      <Form.Item
                        label=''
                        name='retail_date'
                        rules={[
                          {
                            required: true,
                            message: 'Please input retail date ',
                          },
                        ]}
                      >
                        <DatePicker
                          disabledDate={(current) => current && current < dayjs().startOf('day')}
                          format={dateFormat}
                          placeholder='Select Date'
                        />
                      </Form.Item>
                    )}
                  </div>
                </div>
              </Col> */}

                {/* Upload Picture */}
                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <Flex
                    vertical
                    gap={8}
                    className={`lead-form-label ${leadViewDetails?.retail?.document_path
                      ? "picture-uploaded"
                      : ""
                      }`}
                  >
                    <h6 className="me-2">
                      {leadViewDetails?.retail?.document_path ? (
                        "Uploaded Picture:"
                      ) : (
                        <>
                          Upload Pictures:
                          {((!isRetailed && !isLeadConverted) || isEditMode) &&
                            (
                              <span className="asterisk inline-block ml-1">
                                *
                              </span>
                            )}
                        </>
                      )}
                    </h6>
                    <div className="value" style={{ width: "100%" }}>
                      <Form.Item
                        label=""
                        name="document"
                        rules={[
                          {
                            validator: () => {
                              if (
                                fileList?.document &&
                                fileList?.document?.length > 0
                              ) {
                                // Check if file has originFileObj (new upload) or url (existing file)
                                const hasValidFile = fileList.document.some(
                                  (file) =>
                                    file.originFileObj ||
                                    file.url ||
                                    file.status === "done"
                                );
                                if (hasValidFile) {
                                  return Promise.resolve();
                                }
                              }
                              return Promise.reject(
                                new Error("Please upload picture")
                              );
                            },
                          },
                        ]}
                      >
                        {/* <div className="exchange-upload "> */}
                        <Upload
                          maxCount={1}
                          beforeUpload={validateFile}
                          fileList={fileList?.document}
                          accept=".jpg,.jpeg,.png,.gif"
                          maxFileSize={10 * 1024 * 1024}
                          customRequest={({ onSuccess }) => {
                            onSuccess("ok");
                          }}
                          onChange={(info) =>
                            handleFileChange(info, "document")
                          }
                        >
                          <Button icon={<UploadOutlined />}>
                            {" "}
                            Upload Pictures
                          </Button>
                        </Upload>
                        {/* </div> */}
                      </Form.Item>
                    </div>
                  </Flex>
                </Col>

                <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                  <Flex
                    vertical
                    gap={8}
                    className={`lead-form-label  ${leadViewDetails?.retail?.iconnect_doc_path
                      ? "picture-uploaded"
                      : ""
                      }`}
                  >
                    <h6 className="me-2">
                      {leadViewDetails?.retail?.iconnect_doc_path ? (
                        "IConnect:"
                      ) : (
                        <>
                          IConnect:
                          {((!isRetailed && !isLeadConverted) || isEditMode) &&
                            (
                              <span className="asterisk inline-block ml-1">
                                *
                              </span>
                            )}
                        </>
                      )}
                    </h6>
                    <div className="m-0 w-50 value mb-sm-2">
                      <Form.Item
                        label=""
                        name="iconnect_doc"
                        className="mb-0"
                        rules={[
                          {
                            validator: () => {
                              if (
                                fileList?.iconnect_doc &&
                                fileList?.iconnect_doc?.length > 0
                              ) {
                                // Check if file has originFileObj (new upload) or url (existing file)
                                const hasValidFile = fileList.iconnect_doc.some(
                                  (file) =>
                                    file.originFileObj ||
                                    file.url ||
                                    file.status === "done"
                                );
                                if (hasValidFile) {
                                  return Promise.resolve();
                                }
                              }
                              return Promise.reject(
                                new Error("Please upload iconnect picture")
                              );
                            },
                          },
                        ]}
                      >
                        {/* <div className="exchange-upload "> */}
                        <Upload
                          maxCount={1}
                          beforeUpload={validateFile}
                          fileList={fileList?.iconnect_doc}
                          accept=".jpg,.jpeg,.png,.gif"
                          maxFileSize={10 * 1024 * 1024}
                          customRequest={({ onSuccess }) => {
                            onSuccess("ok");
                          }}
                          onChange={(info) =>
                            handleFileChange(info, "iconnect_doc")
                          }
                        >
                          <Button icon={<UploadOutlined />}>
                            Upload IConnect
                          </Button>
                        </Upload>
                        {/* </div> */}
                      </Form.Item>
                    </div>
                  </Flex>
                </Col>

                <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                  <Flex vertical gap={8} className="lead-form-label feedbacks ">
                    <h6>
                      Delivery Feedback:
                    </h6>
                    <div className="value" style={{ width: "100%" }}>
                      <Form.Item
                        name="delivery_feedback"
                        className="mb-0"
                        rules={[
                          {
                            required: false,
                          },
                          {
                            max: 250,
                            message: "Maximum length of 250 characters allowed",
                          },
                        ]}
                      >
                        <Input.TextArea
                          className=""
                          rows={4}
                          placeholder="Delivery Feedback"
                        />
                      </Form.Item>
                    </div>
                  </Flex>
                </Col>

                {/* Retail Remarks */}
                <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                  <Flex vertical gap={8} className="lead-form-label ">
                    <h6 className="me-2">
                      Retail Remarks:
                      {((!isRetailed && !isLeadConverted) || isEditMode) &&
                        (
                          <span className="asterisk inline-block ml-1">*</span>
                        )}
                    </h6>
                    <div className=" value " style={{ width: "100%" }}>
                      <Form.Item
                        name="retail_remarks"
                        label=""
                        rules={[
                          {
                            required: true,
                            message: "Please input retail remarks",
                          },
                        ]}
                      >
                        <Input.TextArea rows={4} placeholder="Retail Remarks" />
                      </Form.Item>
                    </div>
                  </Flex>
                </Col>

                {/* Vehicle Details - Model, Variant, Color, Fuel and Seater */}

                {((!isRetailed && !isLeadConverted) || isEditMode) &&
                  !isLeadCancelled ? (
                  <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <div className="mt-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <Title level={4} className="">
                          Vehicle Details
                        </Title>
                      </div>
                      <Row gutter={[16, 0]} align="middle" className="mb-3">
                        <QuotationVehicleDetails
                          form={form}
                          masterData={masterData}
                          setIsLoading={setIsLoading}
                          setMasterData={setMasterData}
                          excVehicleIds={excVehicleIds}
                          setExcVehicleIds={setExcVehicleIds}
                          isRetailSection={true}
                        />
                      </Row>
                    </div>
                  </Col>
                ) : null}


              </Row>
            </div>
            {/* Save and Cancel Buttons - Show when editing or when no retail data exists */}
            {((!leadViewDetails?.retail && !isLeadConverted) || isEditMode) &&
              (
                <div className="user-right d-flex align-items-center justify-content-end mt-4">
                  {/* Cancel button - Only show when in edit mode */}
                  {isEditMode && (
                    <Button
                      type="primary"
                      ghost
                      danger
                      className="primary-button me-4"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  )}
                  <Button
                    htmlType="submit"
                    type="primary"
                    className="secondary-button"
                    disabled={shouldShowSendForFinalInspection}
                  >
                    Save
                  </Button>

                  {
                    // Hide Send for Final Inspection button when in edit mode
                    // It's already shown next to Edit button in view mode
                    shouldShowSendForFinalInspection && !isEditMode && (
                      <Button
                        type="primary"
                        className="secondary-button ms-3"
                        onClick={openFinalInspectionModal}
                      >
                        Send for Final Inspection
                      </Button>
                    )
                  }
                </div>
              )}
            {/* Edit Button - Show only in view mode when retail data exists and status is Open */}
          </Form>
        ) : (
          <ViewRetailSection
            leadViewDetails={leadViewDetails}
            retailData={retailData}
            handleViewBooking={handleViewBooking}
          />
        )
      ) : (
        <div className="detail-wrapper pt-2">
          <div className="view-input-field">
            <Row gutter={20}>
              <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                <div className="view-fields d-flex align-items-baseline flex-nowrap">
                  <h6 className="me-2 label">Engine Number:</h6>
                  <div className="m-0 w-50 value">
                    {leadViewDetails?.retail?.engine_number ? (
                      <>{retailData?.engine_number}</>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </Col>

              <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                <div className="view-fields d-flex align-items-baseline flex-nowrap">
                  <h6 className="me-2 label">Retail Date:</h6>
                  <div className="m-0 w-50 value">
                    {leadViewDetails?.retail?.retail_date ? (
                      <>
                        {dayjs(retailData?.retail_date).format("DD/MM/YYYY")}{" "}
                      </>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </Col>

              <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                <div className="view-fields d-flex align-items-baseline flex-nowrap">
                  <h6 className="me-2 label">Uploaded Picture:</h6>
                  <div className="m-0 w-50 value">
                    {leadViewDetails?.retail?.document_path ? (
                      <CommanPreviewImage
                        width={100}
                        height={100}
                        src={leadViewDetails?.retail?.document_path}
                      />
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </Col>

              <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                <div className="view-fields d-flex align-items-center flex-nowrap">
                  <h6 className="me-2 label">Delivery Feedback:</h6>
                  <div className="m-0 w-50 value ">
                    {leadViewDetails?.retail?.delivery_feedback ? (
                      <>{retailData?.delivery_feedback}</>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </Col>

              <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                <div className="view-fields d-flex align-items-baseline flex-nowrap">
                  <h6 className="me-2 label">IConnect:</h6>
                  <div className="m-0 w-50 value">
                    {leadViewDetails?.retail?.iconnect_doc_path ? (
                      <CommanPreviewImage
                        width={100}
                        height={100}
                        src={leadViewDetails?.retail?.iconnect_doc_path}
                      />
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </Col>

              <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                <div className="view-fields d-flex align-items-baseline flex-nowrap">
                  <h6 className="me-2 label">Chassis Number:</h6>
                  <div className="m-0 w-50 value">
                    {leadViewDetails?.allocated_chassis_number ? (
                      <>{leadViewDetails?.allocated_chassis_number}</>
                    ) : (
                      leadViewDetails?.retail?.chassis_number
                    )}
                  </div>
                </div>
              </Col>

              <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                <div className="view-fields d-flex align-items-baseline flex-nowrap">
                  <h6 className="me-2 label">Retail Remarks:</h6>
                  <div className="m-0 w-50 value">
                    {leadViewDetails?.retail?.retail_remarks ? (
                      <>{retailData?.retail_remarks}</>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      )}

      <Modal
        title="Send for Final Inspection"
        open={isFinalInspectionModalOpen}
        onOk={handleSendForFinalInspection}
        onCancel={closeFinalInspectionModal}
        okText="Send"
        confirmLoading={isOfficersLoading}
        destroyOnClose
      >
        <Form layout="vertical" form={finalInspectionForm}>
          <Form.Item
            label="Exchange Officer"
            name="exchange_officer_id"
            rules={[
              { required: true, message: "Please select Exchange Officer" },
            ]}
          >
            <Select
              placeholder="Select Exchange Officer"
              loading={isOfficersLoading}
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {exchangeOfficers?.map((officer) => (
                <Select.Option key={officer?.id} value={officer?.id}>
                  {officer?.full_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Retail;
